import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yinshua",
  "use": "icon-yinshua-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yinshua\"><defs><style type=\"text/css\"></style></defs><path d=\"M366.336 742.336h91.328v130.56h95.744v-186.944h91.328v186.944h192V609.28H187.264v263.68h179.008V742.4zM187.328 522.112h649.344V422.592H187.328v99.52z m362.688-186.624V151.104H471.808v184.384h78.208z m-169.536 0V64h260.864v271.488H928V960h-832V335.488h284.48z\" p-id=\"10665\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol